import { InvoiceGeneratorTableContainer } from 'modules/table/components';
export const tableComponents = {
    Container: InvoiceGeneratorTableContainer,
    Footer: () => null,
};
